var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGalleryImport(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.90861 3.85449C4.30867 3.85449 3.81781 4.34535 3.81781 4.9453C3.81781 5.54524 4.30867 6.0361 4.90861 6.0361C5.50856 6.0361 5.99942 5.54524 5.99942 4.9453",
    stroke: "white",
    strokeWidth: 0.818103,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.09079 7.69415V8.76314C1.09079 11.4902 2.18159 12.581 4.9086 12.581H8.18102C10.908 12.581 11.9988 11.4902 11.9988 8.76314V6.03613",
    stroke: "white",
    strokeWidth: 0.818103,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.09021 1.67285H4.9086C2.18159 1.67285 1.09079 2.76366 1.09079 5.49067",
    stroke: "white",
    strokeWidth: 0.818103,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.81723 1.67285V4.94526L10.908 3.85446",
    stroke: "white",
    strokeWidth: 0.818103,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.81724 4.9453L8.72644 3.85449",
    stroke: "white",
    strokeWidth: 0.818103,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1.45624 10.9169L4.14507 9.11163C4.57594 8.82256 5.1977 8.85529 5.58493 9.18798L5.76491 9.34615C6.19033 9.71157 6.87753 9.71157 7.30295 9.34615L9.57182 7.39906C9.99723 7.03365 10.6844 7.03365 11.1099 7.39906L11.9989 8.16263",
    stroke: "white",
    strokeWidth: 0.818103,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGalleryImport);
export default __webpack_public_path__ + "static/media/gallery-import.2757aa2e9fde7db4d99dbeb5afcdb429.svg";
export { ForwardRef as ReactComponent };